import axios from "axios";
import { getCookie } from "../../../App";
import { domain } from "../../Links/Links";
import { useContext } from "react";
import { AuthContext } from "../../SessionChecker/SessionChecker";

export async function addProductRequest(
    name,
    price,
    category,
    photos,
    caption,
    setRequestStatus,
    navigate,
    currentUserUsername,
) {

    

    setRequestStatus({
        loading: true,
        error: null,
    });
    

    try {

        const formData = new FormData();

        formData.append("name", name);
        formData.append("price", price);
        formData.append("category", category);
        formData.append("caption", caption);

        photos.forEach((photo) => {
            formData.append("photos", photo.file);
        });


        const { data } = await axios.post(
            domain + "/add_product/",
            formData,
            {
                withCredentials: true,

                headers: {
                    "X-CSRFToken": getCookie("csrf_token"),
                },
            }
        );


        if (data.status) {

            setRequestStatus({
                loading: false,
                error: null,
            });

            navigate("/" + currentUserUsername);

            return true;

        } else {

            setRequestStatus({
                loading: false,
                error: data.error,
            });

            return false;
        }

    } catch (error) {

        console.error(error);

        setRequestStatus({
            loading: false,
            error: error.response?.data?.error || "Request failed",
        });

        return false;
    }
}


export async function getCategoriesRequest(setCategories) {

    try {

        const { data } = await axios.get(
            domain + "/get_categories/",
            {
                withCredentials: true,

                headers: {
                    "X-CSRFToken": getCookie("csrf_token"),
                },
            }
        );

        if (data.status) {
            setCategories(data.categories);
        }

    } catch (error) {

        console.error(error);

    }
}